import { PersonModalMessage } from "./PersonModalMessage";
import { StudentModalMessage } from "./StudentModalMessage";
import { SessionModalMessage } from "./SessionModalMessage";
import { SystemModalMessage } from "./SystemModalMessage";
export const messageComponents = {
    ...PersonModalMessage,
    ...StudentModalMessage,
    ...SessionModalMessage,
    ...SystemModalMessage
}
export type ModalType = keyof typeof messageComponents;


function ModalMessage({ type }: { type?: ModalType | null }) {

    return type
        ? messageComponents[type]
        : messageComponents['UNKNOWN'];
}

export { ModalMessage }